<template>
  <modal
    name="edit-name-modal"
    classes="v--modal-edit-name"
    height="auto"
    adaptive
    :clickToClose="!requestSent"
    @before-open="beforeOpen"
    @opened="opened"
  >
    <div class="modal-header">
      <div class="header">
        Claim your snake name
        <p class="close-button" v-if="!requestSent">
          <button @click="$modal.hide('edit-name-modal')">
            <i class="fas fa-times"></i>
          </button>
        </p>
      </div>
    </div>

    <div class="modal-content">
      <div class="modal-title">
        How do you want to be known on the snake leaderboard?
        <br />
      </div>

      <form @submit.prevent="handleEditName">
        <div class="modal-content-box">
          <div class="part form">
            <div class="input-group">
              <i class="fas fa-user"></i>
              <input v-model="name" type="text" name="name" size="28" placeholder="Your snake name" />
            </div>
            <div class="input-group">
              <i class="fas fa-envelope"></i>
              <input
                v-model="email"
                type="email"
                name="email"
                size="28"
                placeholder="Your email (zero spam, ever!)"
              />
            </div>
          </div>
        </div>
        <p class="small modal-caption">
          With your email we’ll let you know when your friends send you points
          and when you’ve won a prize. We will never use it for anything else or
          share it with anyone, ever.
        </p>
        <p style="text-align:center;margin-top: 20px">
          <span v-if="requestSent">Saving...</span>
          <button class="img-a-button" type="submit" @click="handleEditName()" v-else>
            <img src="@/assets/btn-save.png" alt="Save" />
          </button>
        </p>
      </form>
    </div>
  </modal>
</template>

<script>
import ShareBox from "@/components/shared/ShareBox";
import { validateEmail, isTempUser } from "@/utils";
import {
  changeEmailAndDisplayName,
  currentUser
} from "../../services/auth.service";
import { trackEvent } from "../../analytics";

export default {
  components: { ShareBox: ShareBox },
  data: () => {
    return {
      email: "",
      titleizedName: "",
      requestSent: false,
      preventModalFromOpeningAgain: false
    };
  },
  computed: {
    isValid() {
      return this.name !== "" && validateEmail(this.email);
    },
    name: {
      set(val) {
        const capitalize = function(str) {
          return str.charAt(0).toUpperCase() + str.slice(1);
        };
        this.titleizedName = val
          .split(" ")
          .map(s => capitalize(s))
          .join(" ");
      },
      get() {
        return this.titleizedName;
      }
    }
  },
  methods: {
    opened() {
      trackEvent("clicked to register");
      if (this.preventModalFromOpeningAgain)
        this.$modal.hide("edit-name-modal");
    },
    async handleEditName() {
      if (!this.isValid && !this.requestSent) return;
      this.requestSent = true;
      trackEvent("saved registration", { alias: this.email });
      // console.log("Changin name: ", this.email, this.titleizedName);
      await Promise.race([
        changeEmailAndDisplayName(this.email, this.titleizedName),
        new Promise((res, rej) => window.setTimeout(res, 2300))
      ]);
      this.preventModalFromOpeningAgain = true;
      this.$modal.hide("edit-name-modal");
    },
    beforeOpen(event) {}
  }
};
</script>

<style lang="scss" scoped>
.part.form {
  margin: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .input-group {
    margin: 15px 0;
    input {
      color: inherit;
      font-size: 0.725rem;
      font-family: inherit;
      margin-left: 8px;
      background: none;
      border: none;
      border-bottom: 3px solid $accent-color;
      &::placeholder {
        color: currentColor;
      }
      &:focus {
        outline: none;
      }
    }
  }
}
.modal-caption {
  padding: 0 50px;
  margin-top: 20px;
}

@media (max-width: 768px) {
  .modal-caption {
    padding: 0 15px;
  }
}
</style>
